// bootstrap component
import { Spinner as BsSpinner } from 'react-bootstrap'

// styles
import classes from './styles.module.scss'

// types
import type { SpinnerProps as BsSpinnerProps } from 'react-bootstrap/Spinner'
import type { variantsEnum } from '@centria-ui/commons/enums'
import type { FC } from 'react'

export interface SpinnerProps extends BsSpinnerProps {
  inline?: boolean
  variant?: keyof typeof variantsEnum
}

export const Spinner: FC<SpinnerProps> = ({
  inline = false,
  className = '',
  variant = 'primary',
  ...props
}) => (
  <div className={`${classes.spinnerContainer} ${inline && classes.contents}`}>
    <BsSpinner
      className={`${className} ${classes[`spinner_${variant}`]}`}
      {...props}
    />
  </div>
)
